import { render, staticRenderFns } from "./CivilAviation.vue?vue&type=template&id=ceca8af6&scoped=true"
import script from "./CivilAviation.vue?vue&type=script&lang=js"
export * from "./CivilAviation.vue?vue&type=script&lang=js"
import style0 from "./CivilAviation.vue?vue&type=style&index=0&id=ceca8af6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceca8af6",
  null
  
)

export default component.exports